import confetti from "canvas-confetti";

export function celebrate() {
  const end = Date.now() + 700;
  const colors = ["#10b981", "#3b82f6", "#f59e0b", "#ffffff"];
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 60, startVelocity: 45, origin: { x: 0, y: 0.7 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 60, startVelocity: 45, origin: { x: 1, y: 0.7 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
